module.exports = __webpack_public_path__ + "img/school.759c37dd.svg";